import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Formulas from "@/pages/Formulas";
import FormulaDetail from "@/pages/FormulaDetail";
import FormulaCompare from "@/pages/FormulaCompare";
import Ingredients from "@/pages/Ingredients";
import Experiments from "@/pages/Experiments";
import ExperimentDetail from "@/pages/ExperimentDetail";
import Feedback from "@/pages/Feedback";
import Packaging from "@/pages/Packaging";
import Documents from "@/pages/Documents";
import Settings from "@/pages/Settings";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center" data-testid="auth-loading">
        <div className="text-[#8C7A6B] text-sm">Loading Smoor R&D OS…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="formulas" element={<Formulas />} />
              <Route path="formulas/compare" element={<FormulaCompare />} />
              <Route path="formulas/:id" element={<FormulaDetail />} />
              <Route path="ingredients" element={<Ingredients />} />
              <Route path="experiments" element={<Experiments />} />
              <Route path="experiments/:id" element={<ExperimentDetail />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="packaging" element={<Packaging />} />
              <Route path="documents" element={<Documents />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </ConfirmProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
